export enum BankContactsColumn {
    fullName = 'fullName',
    linkedIn = 'linkedIn',
    distributionListIcon = 'distributionListIcon',
    title = 'title',
    email = 'email',
    officePhoneNumber = 'officePhoneNumber',
    mobilePhoneNumber = 'mobilePhoneNumber',
}
